import { ref, computed } from 'vue'
import { Invite, Search, Results, Final } from '@/components/invite-through-search'

const step = ref(0)

export const useInviteThroughSearchSteps = () => {
    const steps = [
        {
            identifier: 'initial',
            title: 'Booking Request',
            component: Invite,
            actions: {
                next: null,
                clear: null
            }
        },
        {
            identifier: 'results',
            title: 'Search Artists',
            component: Results,
            actions: {
                next: 'final',
                clear: 'selectedArtists'
            }
        },
        {
            identifier: 'search',
            title: 'Search Artists',
            component: Search,
            actions: {
                next: 'results',
                clear: 'search'
            }
        },
        {
            identifier: 'final',
            title: 'Booking Request',
            component: Final,
            actions: {
                next: null,
                clear: null
            }
        }
    ]
    function updateStep(identifier) {
        step.value = steps.indexOf(steps.find((step) => step.identifier === identifier))
    }

    const currentStep = computed(() => steps[step.value])
    return {
        steps,
        step,
        currentStep,
        updateStep
    }
}
